module.exports = __webpack_public_path__ + "static/media/p51.4ed131db.svg";